const team = [
  {
    image: "./images/adityaGusain.png",
    name: "Aditya Gusain",
    post: "Co-Founder",
    role: "( Full Stack Developer, Head of Strategies )",
    description:
      "He’s experienced in Full Stack Website Development, product management, strategic planning. Loves working in collaboration and managing teams. Best known for creative design thinking and creating outstanding user experience.",
  },
  {
    image: "./images/astu.png",
    name: "Astu",
    post: "Co-Founder",
    role: "(Manager, UI/UX Developer)",
    description: `He’s experienced with handling team with cool mind, has knowledge of UI, UX, WebD, Blockchain. Also has a Youtube channel with 10K+ subscribers.
Love to create content on lifeHacks, productivity, reviews, etc.`,
  },
  {
    image: "./images/rahul.png",
    name: "Rahul",
    post: "Co-Founder",
    role: "( Frontend Developer )",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus luctus sagittis augue, ut venenatis arcu fermentum vel. Duis non sodales nulla. In velit purus, lacinia a lorem sed, aliquam porta nisl. Fusce in augue sed quam vestibulum ",
  },
  {
    image: "./images/atulPanwar.png",
    name: "Atul Panwar",
    post: "Co-Founder",
    role: "(Software Architect )",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus luctus sagittis augue, ut venenatis arcu fermentum vel. Duis non sodales nulla. In velit purus, lacinia a lorem sed, aliquam porta nisl. Fusce in augue sed quam vestibulum ",
  },
];

export default team;
